import styled from 'styled-components';
import { Box, Text } from '@rsos/components/capstone/base';
import { HoveredContainer } from '../../HoveredButton/HoveredButton.styles';

export const CopyRowBox = styled(Box).attrs({
  py: 0,
  px: 0,
  horizontal: true,
  grow: 0,
  align: 'center',
  justify: 'flex-start',
})``;

export const CopyColumnBox = styled(Box).attrs({
  py: 0,
  px: 0,
  justify: 'center',
})`
  border-radius: ${props => props.br || '0'};
`;

export const RowBox = styled(Box).attrs(
  ({ copied, isHoverable, noBg, align }) => ({
    horizontal: true,
    position: 'relative',
    bg: copied ? 'highlights' : 'inherit',
    justify: isHoverable || noBg ? 'space-between' : 'flex-start',
    align: align ? align : 'center',
  }),
)`
  display:flex; //ellipsis overwrite this
  flex-direction: ${props => props.column && 'column'};
  border-radius: ${props => props.br || '0'};
  &:hover ${HoveredContainer} {
    display:${props => (props.isHoverable && !props.noBg ? 'flex' : 'none')};
  }
  &:hover {
    cursor: ${props => (props.isHoverable && !props.noBg ? 'auto' : 'inherit')};
    background: ${props =>
      props.copied
        ? props.theme.colors.highlights
        : props.isHoverable && !props.noBg
          ? props.theme.colors.foreground
          : 'inherit'};
`;

export const LocationAddressContainer = styled(Box).attrs({
  horizontal: false,
  position: 'relative',
  bg: 'inherit',
  justify: 'center',
})`
  border-radius: ${props => props.br || '0'};
`;

export const LeftText = styled(Text).attrs(({ secondary }) => ({
  size: secondary ? 'xsmall' : 'normal',
  color: 'secondaryText',
}))``;

export const MiddleText = styled(Text).attrs(({ secondary }) => ({
  size: secondary ? 'xsmall' : 'normal',
  color: 'primaryText',
}))`
  flex-grow: 1;
  white-space: ${props => (props.wrap ? 'pre-wrap' : 'nowrap')};
`;

export const ButtonText = styled(Text).attrs({
  pl: 2,
})``;

export const LoaderContainer = styled(Box).attrs({
  height: '31px',
  width: '100%',
})`
  & > div {
    height: 28px;
    padding-top: 13px;
    & > div {
      height: 20px;
    }
  }
`;

export const SecondaryText = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
})``;

export const ExtraData = styled(SecondaryText)``;

export const EstimatedAddress = styled(SecondaryText)``;

export const ExtraDataContainer = styled(Box)`
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: ${({ isCompact }) => (isCompact ? '0px' : '10px')};
  div:nth-child(n + 2):not(:last-child) {
    padding-left: 2px;
  }
`;

export const IconWrapper = styled(Box).attrs({
  color: 'secondaryText',
})``;

export const StyledSource = styled(Text).attrs({
  color: 'secondaryText',
  size: 'xsmall',
})``;
